/* eslint-disable quotes */
module.exports = {
  customerStages: {
    lac: 'Lead & Conversion',
    pa: 'Preliminary Analysis',
    ta: 'Technical Analysis',
    dac: 'Disbursement & Compliance',
    crm: 'Customer Relationship Management',
  },
  ratings: {
    AAA: 'Instruments with this rating are considered to have the highest degree of safety regarding timely servicing of financial obligations. Such instruments carry lowest credit risk.',
    AA: 'Instruments with this rating are considered to have high degree of safety regarding timely servicing of financial obligations. Such instruments carry very low credit risk.',
    A: 'Instruments with this rating are considered to have adequate degree of safety regarding timely servicing of financial obligations. Such instruments carry low credit risk.',
    BBB: 'Instruments with this rating are considered to have moderate degree of safety regarding timely servicing of financial obligations. Such instruments carry moderate credit risk.',
    BB: 'Instruments with this rating are considered to have moderate risk of default regarding timely servicing of financial obligations.',
    B: 'Instruments with this rating are considered to have high risk of default regarding timely servicing of financial obligations.',
    C: 'Instruments with this rating are considered to have very high risk of default regarding timely servicing of financial obligations.',
    D: 'Instruments with this rating are in default or are expected to be in default soon',
  },
  customerStatus: [
    'lead-created',
    'lead-further-info-requested',
    'lead-further-info-completed',
    'lead-rejected',
    'lead-accepted',
    'lead-las-completed',
    'lead-las-rejected',
    'lead-las-approved',
    'lead-lcs-further-info-requested',
    'lead-lcs-further-info-completed',
    'lead-lcs-completed',
    'lead-lcs-rejected',
    'lead-lcs-approved',
    'lead-mandate-signed',
    'factsheet',
    'factsheet-rejected',
    'factsheet-approved',
    'factsheet-further-info-requested',
    'factsheet-further-info-completed',
    'factsheet-bank-submission',
    'factsheet-bank-rejected',
    'factsheet-bank-approved',
  ],
  customerEmployeeRoles: [
    'lead-owner',
    'project-owner',
    'lead-analyst',
  ],
};



// WEBPACK FOOTER //
// ./src/utils/lists.js